import { Logo } from "../landing/Logo";
import { WaitlistForm } from "../landing/WaitlistForm";
import { scrollToId } from "../landing/Navbar";
import { Reveal } from "../landing/Reveal";

const LINKS = [
  {
    h: "Bites",
    links: [
      { l: "FoodBite", href: "#foodbite" },
      { l: "LearnBite", href: "#learnbite" },
      { l: "CareerBite", href: "#careerbite" },
      { l: "ShopBite", href: "#shopbite" },
    ],
  },
  {
    h: "More",
    links: [
      { l: "TravelBite", href: "#travelbite" },
      { l: "GreenBite", href: "#greenbite" },
      { l: "Communities", href: "#communities" },
      { l: "Creator Hub", href: "#creator-hub" },
    ],
  },
  {
    h: "Company",
    links: [
      { l: "Partners", href: "#partners" },
      { l: "Investors", href: "#investors" },
      { l: "Download App", href: "#download" },
      { l: "Get Early Access", href: "#claim" },
    ],
  },
];

export const BiteFooter = () => (
  <footer data-testid="bite-footer" className="relative overflow-hidden border-t border-white/5 pb-32 pt-20">
    <div aria-hidden="true" className="absolute -top-28 left-1/2 h-64 w-[640px] -translate-x-1/2 rounded-full bg-[#7C3AED]/12 blur-[130px]" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="flex flex-col items-start gap-7">
        <h2 className="max-w-2xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
          Learn. Create. Eat. Earn. Shop. Travel.{" "}
          <span className="bg-gradient-to-r from-[#7C3AED] via-[#06B6D4] to-[#22C55E] bg-clip-text text-transparent">
            Repeat.
          </span>
        </h2>
        <WaitlistForm compact label="Get Early Access" />
      </Reveal>

      <div className="mt-16 grid grid-cols-2 gap-10 border-t border-white/5 pt-12 sm:grid-cols-4">
        <div className="col-span-2 sm:col-span-1">
          <div className="flex items-center gap-2">
            <Logo className="h-8 w-8" />
            <span className="font-display text-lg font-extrabold tracking-tight text-white">
              FUN<span className="text-[#06B6D4]">Z</span>
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm text-slate-500">
            The Gen Z Operating System — learn, earn, create, connect, shop, travel
            and build your future from one AI-powered platform.
          </p>
        </div>
        {LINKS.map((col) => (
          <div key={col.h}>
            <p className="font-jbmono text-[11px] uppercase tracking-[0.25em] text-slate-500">{col.h}</p>
            <ul className="mt-4 space-y-3">
              {col.links.map((link) => (
                <li key={link.l}>
                  <a
                    href={link.href}
                    onClick={scrollToId(link.href)}
                    data-testid={`bite-footer-${link.l.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="text-sm text-slate-400 transition-colors hover:text-[#06B6D4]"
                  >
                    {link.l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/5 pt-8 sm:flex-row">
        <p className="font-jbmono text-[11px] uppercase tracking-[0.2em] text-slate-600">
          © 2026 FUNZ · Made for Gen Z
        </p>
        <p className="font-jbmono text-[11px] uppercase tracking-[0.2em] text-slate-600">
          🍔 📚 💼 🛍 ✈️ 🌱
        </p>
      </div>
    </div>
  </footer>
);
